import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CustomerOrders from "../components/CustomerOrders";

const OrdersPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Customer Orders' />

        {/* GalleryLayer */}
        <CustomerOrders />
      </MasterLayout>
    </>
  );
};

export default OrdersPage;